import * as api from "../transport/api/run-api.js";
import * as store from "./stores/run-store.js";

export async function loadRuns(sessionId) {
  if (!sessionId) return store.clearRuns();
  store.beginLoad(sessionId);
  try {
    const runs = await api.listRuns({ sessionId });
    if (store.getRunState().sessionId === sessionId) store.setRuns(sessionId, runs);
  } catch (error) {
    if (store.getRunState().sessionId === sessionId) store.setError(sessionId, error);
  }
}

export function startLiveRun({ runId, sessionId, assistantMessageId, title }) {
  store.upsertRun({ runId, sessionId, assistantMessageId, title: String(title || "Agent 任务").slice(0, 100), status: "QUEUED", phase: "queued", startedAt: null });
}

export function updateLiveRun(runId, patch) {
  const run = store.getRunState().runs.find((item) => item.runId === runId);
  if (run) store.upsertRun({ ...run, ...patch, updatedAt: new Date().toISOString() });
}

export { store as runStore };
